import React from 'react';

const CommunityImg = (props) => {
  return (
    <img {...props} />
  )
}

export default CommunityImg ;